// Copyright (c) 2020-2023 dātma, inc™
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { tumorBoardBaseUrl } from '@/settings'

// Scheduling example:
// https://pathreport.dev.datma.com/tumor_board/api/v1/tbsession_details?mrn=0xD1D9972186F7C8C0DA69637FAF6F4F124422198A46CB49BEF3A4B43F59E796EF&date=2023-06-25

const callPatientEhrWithTimeout = async (data, query, baseUrl) => {
  try {
    const fetchParams = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }
    const url = `${baseUrl}?${query}=${encodeURIComponent(data)}`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return []
    }
    const result = await response.json()
    if (!result) { return [] }
    // Translate the response to the format expected by the frontend.
    return result
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}

export const getRecord = async (mrn) => await callPatientEhrWithTimeout(mrn, 'mrn', `${tumorBoardBaseUrl}/api/v1/tbsession_details`)
